import React, { useEffect, useState } from "react";
import { Radio, ArrowRight } from "lucide-react";
import { fetchUpdates } from "../lib/api";

const FALLBACK = [{ time: "--:--", old: "--", fresh: "--" }];

export default function LiveTicker() {
  const [items, setItems] = useState(FALLBACK);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let mounted = true;
    fetchUpdates()
      .then((data) => {
        if (!mounted) return;
        if (data && data.length) setItems(data);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % items.length), 2800);
    return () => clearInterval(id);
  }, [items.length]);

  const cur = items[idx] || FALLBACK[0];

  return (
    <div className="bg-gradient-to-r from-rose-950/60 via-amber-950/40 to-rose-950/60 border-y border-amber-400/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 text-sm">
        <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded bg-rose-500/20 text-rose-300 text-[11px] font-semibold uppercase tracking-wider">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-rose-500"></span>
          </span>
          Live
        </span>
        <Radio className="w-4 h-4 text-amber-300" />
        <span className="text-slate-300 font-medium">Live Updates</span>
        <span className="text-slate-500">|</span>
        <div className="flex-1 overflow-hidden">
          <div key={idx} className="animate-[slideIn_0.6s_ease-out] flex items-center gap-2 text-slate-200">
            <span className="text-amber-300 font-mono">{cur.time}</span>
            <span className="text-slate-500">Old</span>
            <span className="font-mono font-semibold text-rose-300">{cur.old}</span>
            <ArrowRight className="w-3.5 h-3.5 text-slate-500" />
            <span className="text-slate-500">New</span>
            <span className="font-mono font-bold text-emerald-300">{cur.fresh}</span>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes slideIn { from { opacity: 0; transform: translateX(20px);} to { opacity: 1; transform: translateX(0);} }
      `}</style>
    </div>
  );
}
